<template>
  <div>
    <h3>Online</h3>
    <p><input type="button" v-on:click="login()" value="Set UserContext"/></p>
    <p><input type="button" @click="logout()" value="Clear UserContext"/></p>
    <p>Your username is <b>{{ userContext.userName }}</b></p>
    <p>OrgId is <b>{{ userContext.orgId }}</b></p>
  </div>
</template>

<script>
  import SessionContext from '@/assets/js/sessionContext.js'

  export default {
    name: 'app',
    data () {
      return {
        userContext: SessionContext.getUserContext()
      }
    },
    methods: {
      login: function () {
        // Request Server
        var userContext = {
          orgId: 'zhou',
          userId: '100',
          userName: 'Admin'
        }
        SessionContext.setUserContext(userContext)
        this.userContext = userContext
      },
      logout: function () {
        SessionContext.clearUserContext()
        this.userContext = {}
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/about/component/online.vue